import type { Feature } from 'src/modules/FeatureToggler/types';

export const getFeatureByName = (
  features: Feature[],
  name: string,
): Feature | undefined => features?.find((f) => f.name === name);
